import {
  AuthService,
  IdentityAccessValueFactory,
  PolicyService,
  provideIdentityAccessPermissions,
} from '@finverity/identity-access';

import { RequiredContractsPermission } from './required-contracts-permission.enum';

// TODO: FDS-4267 Replace stopgap with real BE policy checks once required-contracts policies land.
// Until then: any authenticated user may view their generated contracts, and only authorised
// signatories may generate/sign. The No Signature (review-only) method carries no legal signature,
// so it is open to any user who can manage the company — gated by MANAGE_MY_COMPANY_CUSTOMER.
const REQUIRED_CONTRACTS_IDENTITY_ACCESS_FACTORY: IdentityAccessValueFactory<RequiredContractsPermission> = (
  authService: AuthService,
  policyService: PolicyService
) => {
  const user = authService.authUser();
  const isAuthenticated = !!user;
  const isAuthorisedSignatory = user?.is_authorised_signatory === true;

  return {
    [RequiredContractsPermission.ViewGeneratedContracts]: isAuthenticated,
    [RequiredContractsPermission.GenerateContract]: isAuthorisedSignatory,
    [RequiredContractsPermission.AcceptContract]: isAuthorisedSignatory,
    [RequiredContractsPermission.ManageMyCompany]: policyService.hasPermissions('MANAGE_MY_COMPANY_CUSTOMER'),
  };
};

export const REQUIRED_CONTRACTS_IDENTITY_ACCESS_PROVIDER = provideIdentityAccessPermissions(
  REQUIRED_CONTRACTS_IDENTITY_ACCESS_FACTORY
);
